var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRank10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_1_7619)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0565 13.5V12.5H6.7065V8.18H5.0465V7.43C5.2465 7.41 5.47983 7.36333 5.7465 7.29C6.01983 7.21 6.2965 7.11333 6.5765 7C6.8565 6.88667 7.10983 6.76667 7.3365 6.64H7.9365V12.5H9.4565V13.5H5.0565ZM13.0515 13.62C12.6782 13.62 12.3449 13.5667 12.0515 13.46C11.7582 13.3467 11.5082 13.1567 11.3015 12.89C11.0949 12.6233 10.9382 12.2633 10.8315 11.81C10.7249 11.35 10.6715 10.77 10.6715 10.07C10.6715 9.37 10.7249 8.79333 10.8315 8.34C10.9382 7.88 11.0949 7.51667 11.3015 7.25C11.5082 6.98333 11.7582 6.79667 12.0515 6.69C12.3449 6.57667 12.6782 6.52 13.0515 6.52C13.4249 6.52 13.7549 6.57667 14.0416 6.69C14.3349 6.79667 14.5849 6.98333 14.7915 7.25C14.9982 7.51667 15.1549 7.88 15.2615 8.34C15.3682 8.79333 15.4216 9.37 15.4216 10.07C15.4216 10.77 15.3682 11.35 15.2615 11.81C15.1549 12.2633 14.9982 12.6233 14.7915 12.89C14.5849 13.1567 14.3349 13.3467 14.0416 13.46C13.7549 13.5667 13.4249 13.62 13.0515 13.62ZM13.0515 12.62C13.3649 12.62 13.5982 12.5367 13.7515 12.37C13.9116 12.1967 14.0182 11.9433 14.0715 11.61C14.1315 11.27 14.1615 10.85 14.1615 10.35V9.83C14.1615 9.31667 14.1315 8.89 14.0715 8.55C14.0182 8.20333 13.9116 7.94667 13.7515 7.78C13.5982 7.60667 13.3649 7.52 13.0515 7.52C12.7449 7.52 12.5082 7.60667 12.3415 7.78C12.1815 7.94667 12.0715 8.2 12.0115 8.54C11.9582 8.87333 11.9315 9.29333 11.9315 9.8V10.32C11.9315 10.8267 11.9582 11.2533 12.0115 11.6C12.0715 11.94 12.1815 12.1967 12.3415 12.37C12.5082 12.5367 12.7449 12.62 13.0515 12.62Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_7619",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#342F86"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank10);
export default __webpack_public_path__ + "static/media/rank10.9e62c5b51742d68bf08ca068ffb973be.svg";
export { ForwardRef as ReactComponent };